(function () {
    let sizeOptions = document.querySelectorAll(".js-variant-add-to-cart");
    sizeOptions.forEach(function (sizeOption) {
        // sizeOption.addEventListener("click", _sizeAddtoCartEvent.bind(this),false);
    });

    function _sizeAddtoCartEvent(event) {
        let variantId = parseInt(event.target.querySelector("input").getAttribute("data-variant-id"));
        console.log(event.target)
        let formData = {
            'items': [{
                'id': variantId,
                'quantity': 1
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then(response => {
                const cartCustomContent = fetch(`${Shopify.routes.root}cart.js`);
                console.log(JSON.parse(cartCustomContent))
                cartCustomContent["sections"] = response["sections"];
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: cartCustomContent
                    }
                }));
                console.log(response)

            })
        // .catch((error) => {
        //   console.error('Error:', error);
        // });
    }

    let productGridAddToCartButtons = document.querySelectorAll(".js-grid-add-to-cart-button");
    productGridAddToCartButtons.forEach(function (productGridAddToCartButton) {
        productGridAddToCartButton.addEventListener("click", _customAddToCart.bind(this), false);
    });

    function _customAddToCart(event) {
        console.log(event)
        event.target.closest(".product-card").querySelector(".product-card__quick-buy").querySelector("button").click()
    }
})();

window._handleLoadMoreClick = function _handleLoadMoreClick(evt) {
    console.log(evt);
    let loadMoreBtn = evt.currentTarget;
    loadMoreBtn.setAttribute("disabled", true);
    loadMoreBtn.setAttribute("loading", true);
    let totalPages = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-total-pages]").value);
    let currentPage = parseInt(loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value);
    currentPage = currentPage + 1;
    loadMoreBtn.closest(".shopify-section").querySelector("[data-current-page]").value = currentPage;
    let nextPageURL = loadMoreBtn.closest(".shopify-section").querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage)
    fetch(nextPageURL, { method: "GET", headers: { "Content-type": "application/json; charset=UTF-8" } })
        .then(res => res.text())
        .then((response) => {
            // console.log(response);
            let parser = new DOMParser();
            let newHtml = parser.parseFromString(response, "text/html");
            // console.log(newHtml)
            // console.log(loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector("#article-grid"))
            if (loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").querySelector(".js-color-swatch-aftergyratips-loop")) {
                loadMoreBtn.closest(".shopify-section").querySelector("#Huratips-Loop").insertAdjacentHTML("beforeend", newHtml.querySelector("#Huratips-Loop").querySelector(".js-color-swatch-aftergyratips-loop").innerHTML);
            }
            loadMoreBtn.removeAttribute("loading");
            if (currentPage <= totalPages) {
                loadMoreBtn.removeAttribute('disabled');
            }
            console.log(currentPage, totalPages)
            if (currentPage == totalPages) {
                loadMoreBtn.closest(".shopify-section").querySelector(".pagination-infinite").classList.add("hide");
                loadMoreBtn.closest(".load-more_wrap").classList.add("hide");
                loadMoreBtn.closest(".shopify-section").querySelector(".js-color-swatch-aftergyratips-loop").classList.add("tw-mb-8");
            }
            if (typeof scheduleProductCardSwiperInit === 'function') {
                scheduleProductCardSwiperInit();
            } else if (typeof window.initProductCardSwiper === 'function') {
                window.initProductCardSwiper();
            }
        });
}
let loadMoreButtons = document.querySelectorAll(".js-load-more");
loadMoreButtons.forEach((loadMoreButton) => {
    // console.log(loadMoreButton);
    loadMoreButton.addEventListener("click", window._handleLoadMoreClick.bind(this), true);
});

// const swiper = new Swiper('.gift_product-slider', {
//     // pagination: {
//     //     el: '.gift-swiper-pagination',
//     //     clickable: true,
//     // },
//     navigation: {
//         nextEl: '.swiper-button-next-btn',
//         prevEl: '.swiper-button-prev-btn',
//     },
// });

document.addEventListener('DOMContentLoaded', function () {

    const allMainUl = document.querySelectorAll('.header-swatch-grid');
    allMainUl.forEach(mainUl => {
        const moreLessBtn = mainUl.nextElementSibling;
        const showMoreBtn = moreLessBtn.querySelector('.showMoreBtn');
        const showLessBtn = moreLessBtn.querySelector('.showLessBtn');

        showMoreBtn.addEventListener('click', () => {
            mainUl.classList.add('swatch-show-cover');
            showMoreBtn.style.display = "none";
            showLessBtn.style.display = "block";
        });

        showLessBtn.addEventListener('click', () => {
            mainUl.classList.remove('swatch-show-cover');
            showMoreBtn.style.display = "block";
            showLessBtn.style.display = "none";
        });
    });

    const swatch_main_div_product_page = document.querySelector('fieldset .pcs-cover');

    if (swatch_main_div_product_page) {
        const more_less_btn_product = document.querySelector('.more_less_btn_product');
        const _showMoreBtn = more_less_btn_product.querySelector('.showMoreBtn_');
        const _showLessBtn = more_less_btn_product.querySelector('.showLessBtn_');

        _showMoreBtn.addEventListener('click', () => {
            swatch_main_div_product_page.classList.add('swatch-show-cover');
            _showMoreBtn.style.display = "none";
            _showLessBtn.style.display = "block";
        });
        _showLessBtn.addEventListener('click', () => {
            swatch_main_div_product_page.classList.remove('swatch-show-cover');
            _showMoreBtn.style.display = "block";
            _showLessBtn.style.display = "none";
        });
    }

    const readMoreLinks = document.querySelectorAll('.pera-text-more a');
    readMoreLinks.forEach(function (readMoreLink) {
        readMoreLink.addEventListener('click', function () {
            var peraTextParent = readMoreLink.closest('.pera-text');
            peraTextParent.classList.add('show-text');
        });
    });
});

const rating_main_class = document.querySelector('.product .product__review_zero');
if (rating_main_class) {
    setTimeout(() => {
        const ratingDivs = rating_main_class.querySelectorAll('[data-oke-star-rating]');

        ratingDivs.forEach((oke_star_rating_div) => {
            if (oke_star_rating_div) {
                const __star_rating = oke_star_rating_div.parentElement.classList.add('hidden');
            }
        });
    }, 100);
}

const tabs = document.querySelectorAll(".tab");

function tabify(tab) {
    const tabList = tab.querySelector(".tablist");

    if (tabList) {
        const tabItems = [...tabList.children];
        const tabContent = tab.querySelector(".tab__content");
        const tabContentItems = [...tabContent.children];
        let tabIndex = 0;
        let allTagsEle = tab.querySelector('.current_product_tags');
        if(allTagsEle){
          var allTags = allTagsEle.innerText;
          var saperatedTags = allTags.split(',');
        }
        tabIndex = tabItems.findIndex((item, index) => {
            return [...item.classList].indexOf("active") > -1;
        });

        tabIndex > -1 ? (tabIndex = tabIndex) : (tabIndex = 0);

        function setTab(index) {
            tabItems.forEach((x, index) => x.classList.remove("active"));
            tabContentItems.forEach((x, index) => x.classList.remove("active"));

            tabItems[index].classList.add("active");
            tabContentItems[index].classList.add("active");
        }

        tabItems.forEach((x, index) =>{
          var tabName = x.textContent;
          var tabNameHandleize = tabName.toLowerCase().replaceAll(' ', '-');
          if(saperatedTags){            
            saperatedTags.forEach(tag=>{
              if(tag == tabNameHandleize){
                // console.log(index);
                setTab(index);
              } else{
                var newTag = tag.concat('s');
                if(newTag == tabNameHandleize){
                  // console.log(index);
                  setTab(index);
                }
              }
            })
          }
        });
      
        // setTab(tabIndex);
        tabItems.forEach((x, index) =>
            x.addEventListener("click", () => setTab(index))
        );
        tab.querySelectorAll(".tab").forEach((tabContent) => tabify(tabContent));
    }
}

tabs.forEach(tabify);

// _________________ Description Read More Read Less Functionality on Product page _________________
var DescriptionElements = document.querySelectorAll('.desc--description');
if (DescriptionElements.length > 0) {
    DescriptionElements.forEach(ele => {
        var EleContent = '';
        const ReadMoreButton = ele.querySelector('.ReadMore');
        const ReadMoreButtonCMSValue = ReadMoreButton.getAttribute('data-cms-value');
        if (ele.querySelector('.accordion__content')) {
            EleContent = ele.querySelector('.accordion__content');
        } else if (ele.querySelector('.product-info__description')) {
            EleContent = ele.querySelector('.product-info__description');
        }
        if (ReadMoreButton) {
            ReadMoreButton.addEventListener('click', () => {
                if (EleContent.classList.contains('element_expanded_false')) {
                    EleContent.classList.remove('element_expanded_false');
                    EleContent.classList.add('element_expanded');
                    ReadMoreButton.innerText = "Read Less";
                } else {
                    EleContent.classList.add('element_expanded_false');
                    EleContent.classList.remove('element_expanded');
                    ReadMoreButton.innerText = ReadMoreButtonCMSValue;
                }
            })
        }
    })
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tab-target').forEach(function (tabLink) {
        tabLink.addEventListener('click', function () {
            document.querySelectorAll('.model-form-row').forEach(function (tab) {
                tab.classList.remove('tab-active');
            });

            var tabId = this.getAttribute('data-id');
            document.querySelector(".model-form-row[data-id='" + tabId + "']").classList.add('tab-active');

            document.querySelectorAll('.tab-target').forEach(function (tabLink) {
                tabLink.classList.remove('tab-active');
            });
            this.classList.add('tab-active');
        });
    });
});

if (document.querySelector('.read_more_btn')) {
    const Read_More_Btn = document.querySelector('.read_more_btn');
    const Read_More_Btn_Span = Read_More_Btn.querySelector('span');
    const Read_More_Btn_Main_Div = document.querySelector('.seo_sec_main._SEO_Desc_Div');
    if (Read_More_Btn) {
        Read_More_Btn_Span.addEventListener('click', () => {
            if (Read_More_Btn.classList.contains('read_more_exist')) {
                Read_More_Btn.querySelector('span').textContent = "- Read Less";
                Read_More_Btn.classList.remove('read_more_exist');
                if (Read_More_Btn_Main_Div) { Read_More_Btn_Main_Div.classList.remove('_read_more_toggle'); }
            } else {
                Read_More_Btn.querySelector('span').textContent = "+ Read More";
                Read_More_Btn.classList.add('read_more_exist');
                if (Read_More_Btn_Main_Div) { Read_More_Btn_Main_Div.classList.add('_read_more_toggle'); }
            }
        })
    }
}

(function(){
  const bundleSizeBtns = document.querySelectorAll(".product input[name='size-option-2']");
  if(!bundleSizeBtns.length) return;

  bundleSizeBtns.forEach((bundleSizeBtn)=> bundleSizeBtn.addEventListener("click", handleBundleSize.bind(this), true));

  function handleBundleSize(event){
    const currentSelectedSizeOption = document.querySelector(".product input[name='size-option-2']:checked");
    const currentValue = currentSelectedSizeOption.value;
    const optionWrapper = event.currentTarget.closest(".custom-variant-picker");
    const optionLabel = optionWrapper.querySelector(".custom-variant-label .current-value");
    optionLabel.textContent = currentValue;
  }
})();



document.addEventListener('DOMContentLoaded', function() {
    var accordionToggle = document.querySelector('.product-info__accordion .accordion__toggle');
    if (accordionToggle) {
        accordionToggle.click();
    }
});








document.addEventListener("DOMContentLoaded", function() {
    const tablinks = document.querySelectorAll(".tablinks");

    tablinks.forEach(button => {
        button.addEventListener("click", function() {
            openTab(this);
        });
    });

    function openTab(button) {
        var i, tabcontent, tablinks;

        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        const tabName = button.getAttribute("data-tab");
        document.getElementById(tabName).style.display = "block";
        button.className += " active";
    }

    if (tablinks.length > 0) {
        openTab(tablinks[0]);
    }
});





document.addEventListener('DOMContentLoaded', () => {
    const tables = document.querySelectorAll('.tabbings-size-new .size-table');

    if (tables.length > 0) {
        tables.forEach(table => {
            table.addEventListener('mouseover', (event) => {
                if (event.target.tagName === 'TD') {
                    const hoveredCell = event.target;
                    const rowIndex = hoveredCell.parentElement.rowIndex;
                    const cellIndex = hoveredCell.cellIndex;
                    removeHighlight(table);
                    const rows = table.querySelectorAll('tr');
                    rows.forEach(row => {
                        const cell = row.cells[cellIndex];
                        if (cell) {
                            cell.classList.add('highlight');
                        }
                    });
                }
            });

            table.addEventListener('mouseout', (event) => {
                if (event.target.tagName === 'TD') {
                    removeHighlight(table);
                }
            });

            function removeHighlight(table) {
                table.querySelectorAll('.highlight').forEach(cell => cell.classList.remove('highlight'));
            }
        });
    }
});




document.addEventListener('DOMContentLoaded', () => {
    const tabbingsSizeNewElements = document.querySelectorAll('.tabbings-size-new');
    const sizeInches = document.getElementById('size_inches');
    const sizeCentimeters = document.getElementById('size_centimeters');

    if (tabbingsSizeNewElements.length > 0) {
        function updateClass() {
            tabbingsSizeNewElements.forEach(el => {
                if (sizeInches.checked) {
                    el.classList.add('enable_inches');
                    el.classList.remove('enable_centimeters');
                } else if (sizeCentimeters.checked) {
                    el.classList.add('enable_centimeters');
                    el.classList.remove('enable_inches');
                }
            });
        }

        sizeInches.addEventListener('change', updateClass);
        sizeCentimeters.addEventListener('change', updateClass);
    }
});

// Open size chart instead redirect on link.
document.addEventListener('DOMContentLoaded', () => {
  const SizeFitAccordion = document.querySelector('.accordion_size-fit');
  if(SizeFitAccordion){
    const innerInputvalue = SizeFitAccordion.querySelector('input')?.value;
    const innerAnchor = SizeFitAccordion.querySelector('.prose')?.querySelector('p')?.querySelector('a');
    if(innerAnchor){
      innerAnchor.addEventListener('click',(evt)=>{
        if(innerInputvalue === 'true'){
          evt.preventDefault();
          const sizeChart = SizeFitAccordion.closest('.product-info')?.querySelector('variant-picker')?.querySelector('.size_chart_link')?.querySelector('.link');
          if(sizeChart){
            sizeChart.click();
          }
        }
      })
    }
  }
});

// Sale code functionality on password page as well BFCM 24 sign up  page.
const AllSaleForms = document.querySelectorAll('.sale-code-form-main');
if(AllSaleForms.length > 0){
  AllSaleForms.forEach(sale_form=>{
    const submit_button = sale_form?.querySelector('.button');
    submit_button?.addEventListener('click', ()=>{
      const input_field_value = sale_form?.querySelector('input')?.value;
      if(input_field_value != ''){
        const sale_text = sale_form.querySelector('.sale_dummy_text');
        if(sale_text.hasAttribute('hidden')){          
          sale_text.removeAttribute('hidden');
        }
        setTimeout(()=>{
          sale_text.setAttribute('hidden', true);
        }, 5000);
      }
    })
  })
}

window.initProductCardSwiper = function () {
    if (typeof Swiper === 'undefined') {
        return false;
    }

    var desktopQuery = window.matchMedia('(min-width: 1025px)');

    document.querySelectorAll('.product-card-swiper').forEach(function (el) {
        if (el.classList.contains('swiper-initialized')) {
            return;
        }

        var slideCount = el.querySelectorAll('.swiper-slide').length;
        if (slideCount === 0) {
            return;
        }

        var figure = el.closest('.product-card__figure');
        var swiper = new Swiper(el, {
            loop: false,
            initialSlide: 1,
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                1025: {
                    initialSlide: 1,
                },
            },
            speed: 400,
        });

        if (!figure || slideCount <= 1) {
            return;
        }

        // var hasClickedNext = false;
        // var nextBtn = el.querySelector('.swiper-button-next');

        // figure.addEventListener('mouseenter', function () {
        //     if (!desktopQuery.matches || slideCount <= 1) {
        //         return;
        //     }

        //     if (swiper.activeIndex === 0) {
        //         hasClickedNext = false;
        //         swiper.slideTo(1, 400);
        //     }
        // });

        // figure.addEventListener('mouseleave', function () {
        //     if (!desktopQuery.matches) {
        //         return;
        //     }

        //     if (!hasClickedNext) {
        //         swiper.slideTo(0, 400);
        //     }
        // });

        // if (nextBtn) {
        //     nextBtn.addEventListener('click', function () {
        //         if (desktopQuery.matches) {
        //             hasClickedNext = true;
        //         }
        //     });
        // }
    });

    return true;
};

function scheduleProductCardSwiperInit() {
    if (window.initProductCardSwiper()) {
        return;
    }

    var attempts = 0;
    var interval = setInterval(function () {
        if (window.initProductCardSwiper() || ++attempts >= 30) {
            clearInterval(interval);
        }
    }, 250);
}

scheduleProductCardSwiperInit();
window.addEventListener('load', scheduleProductCardSwiperInit);
document.addEventListener('shopify:section:load', scheduleProductCardSwiperInit);
window.scheduleProductCardSwiperInit = scheduleProductCardSwiperInit;


window.quickBUyCustomEvent = function(){
    const drawers = document.querySelectorAll('quick-buy-drawer');
    if (drawers.length > 0) {
        const lastDrawer = drawers[drawers.length - 1];        
        const cartButton = lastDrawer.querySelector('.cartButton');        
        if (cartButton) {
            const cartIconLink = document.querySelector('.header__icon-list a[aria-controls="cart-drawer"]');
            if (cartButton && cartIconLink) {
                cartButton.addEventListener('click', function (event) {
                event.preventDefault();
                const CartDrawerAlreadyOpen = document.querySelector('cart-drawer.cart-drawer').hasAttribute('open');
                document.querySelector('cart-drawer.cart-drawer') && CartDrawerAlreadyOpen ? document.querySelector('cart-drawer.cart-drawer').click() : cartIconLink.click();
                });
            }
        } else {
            console.error('Cart button not found in the last drawer');
        }
    } else {
        console.error('No drawers found on the page');
    }
}


function initCartUpsellSwiper() {
    if (typeof Swiper === 'undefined') {
        return false;
    }

    document.querySelectorAll('.mySwiper_upsell').forEach(function (el) {
        if (el.swiper) {
            return;
        }

        var container = el.closest('.active_cart_upsell_products_main');
        new Swiper(el, {
            slidesPerView: 1.2,
            spaceBetween: 10,
            watchOverflow: true,
            navigation: {
                nextEl: container ? container.querySelector('.swiper-button-next-btn') : '.swiper-button-next-btn',
                prevEl: container ? container.querySelector('.swiper-button-prev-btn') : '.swiper-button-prev-btn',
            },
        });
    });

    return true;
}

function scheduleCartUpsellSwiperInit() {
    if (window._cartUpsellSwiperTimer) {
        return;
    }

    if (initCartUpsellSwiper()) {
        return;
    }

    var attempts = 0;
    window._cartUpsellSwiperTimer = setInterval(function () {
        if (initCartUpsellSwiper() || ++attempts >= 40) {
            clearInterval(window._cartUpsellSwiperTimer);
            window._cartUpsellSwiperTimer = null;
        }
    }, 250);
}

window.activeCartUpsellSwiper = function () {
    if (initCartUpsellSwiper()) {
        return true;
    }

    scheduleCartUpsellSwiperInit();
    return false;
};

scheduleCartUpsellSwiperInit();
window.addEventListener('load', scheduleCartUpsellSwiperInit);

function getActiveCartUpsellItem(element) {
    return element ? element.closest('.active_cart_upsell_products_slider_item') : null;
}

function updateActiveCartUpsellVariant(select) {
    var item = getActiveCartUpsellItem(select);
    if (!item) {
        return;
    }

    var idInput = item.querySelector('.active_cart_upsell_product_id');
    var selectedOption = select.options[select.selectedIndex];
    if (idInput && select.value) {
        idInput.value = select.value;
    }

    var priceEl = item.querySelector('.active_upsell_main_price');
    var compareEl = item.querySelector('.active_upsell_main_compare_price');
    if (priceEl && selectedOption && selectedOption.getAttribute('data-price')) {
        priceEl.textContent = selectedOption.getAttribute('data-price');
    }
    if (compareEl) {
        var comparePrice = selectedOption ? selectedOption.getAttribute('data-compare-price') : '';
        if (comparePrice) {
            compareEl.textContent = comparePrice;
            compareEl.removeAttribute('hidden');
        } else {
            compareEl.textContent = '';
            compareEl.setAttribute('hidden', 'true');
        }
    }
}

function addActiveCartUpsellToCart(button) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (button.disabled || button.getAttribute('aria-busy') === 'true') {
        return;
    }

    var item = getActiveCartUpsellItem(button);
    if (!item) {
        return;
    }

    var idInput = item.querySelector('.active_cart_upsell_product_id');
    var variantId = idInput ? parseInt(idInput.value, 10) : NaN;
    if (!variantId) {
        return;
    }

    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-busy', 'true');

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
    }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1
            }],
            sections: sectionsToBundle
        })
    })
        .then(function (response) {
            return response.json().then(function (json) {
                return { ok: response.ok, json: json };
            });
        })
        .then(function (result) {
            cartDrawer._onCartRefresh();
        })
        .catch(function (error) {
            console.error('Error:', error);
            button.removeAttribute('disabled');
            button.removeAttribute('aria-busy');
        });
}

document.addEventListener('change', function (event) {
    var select = event.target.closest('.active_cart_upsell_products_variants');
    if (!select) {
        return;
    }
    updateActiveCartUpsellVariant(select);
});

document.addEventListener('click', function (event) {
    var button = event.target.closest('.add-active-cart-upsell__cart');
    if (!button) {
        return;
    }
    event.preventDefault();
    addActiveCartUpsellToCart(button);
});
